// the default locale
// you can for example take it from the URL.
let locale = document.documentElement.getAttribute('lang');

// the translation data
// you can load/fetch these from files or keep them hardcoded.
let messages = {
  cs: {
    inside_cabin: 'Vnitřní kajuta',
    price_included: 'V ceně zájezdu',
    free: 'Zdarma',
    on_inquiry: 'Na dotaz',
  },
  en: {
    inside_cabin: 'Inner cabin',
    price_included: 'Included in the price of the tour',
    free: 'Free',
    on_inquiry: 'On inquiry',
  },
  pl: {
    inside_cabin: 'Wewnątrz kabiny',
    cena_included: 'W cenie wycieczki',
    bezpłatny: 'Bezpłatny',
    on_inquiry: 'Na zapytanie',
  },
  sk: {
    inside_cabin: 'Vnútorná kajuta',
    price_included: 'V cene zájazdu',
    free: 'Zdarma',
    on_inquiry: 'Na dopyt',
  },
};

// finally, pass them to AlpineI18n:
document.addEventListener('alpine-i18n:ready', function () {
  window.AlpineI18n.create(locale, messages);
});
